import axiosConfig from "../../../utils/axiosConfig";

const BASE_PATH = "pages/attendance/active_clients_chart";

export const api = {
  getChart(params) {
    return axiosConfig.post(BASE_PATH, params);
  },
  getFilters(params) {
    return axiosConfig.get(`${BASE_PATH}/filters`, { params });
  }
};
